<template>
  <div id="remarkable" v-html="compiledMarkdown"></div>
</template>

<script>
  import Remarkable from 'remarkable';

  export default {
    name: 'remarkable',

    props: ['value'],

    data() {
      return {};
    },
    computed: {
      compiledMarkdown() {
        return new Remarkable('full').render(this.value);
      },
    },
    methods: {},
  };
</script>

<style lang="scss">
  #remarkable {
    position: absolute;
    bottom: 0; right: 0; top: 0; left: 0;
    z-index: 1000;
    background: white;
    overflow-y: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/MarkdownToHtml.vue?9b607704